/**
 * Module definition and dependencies
 */
angular.module("Crm.FormContact.Controller", [//"App.StringToNumberDirective",
//"ngMessages",
"contactsService.Service", "configsService.Service", "documentsService.Service", "programmesService.Service", "membresService.Service", "transactionsService.Service", "ngFileUpload", //"App.asScrollOnClickDirective",
//"rzModule",
//"App.asScrollOnClickDirective",
//"App.ContacterContacts.Controller",
"documentsService.Service", "selectionsService.Service", "denoncesService.Service"])
/**
 * Controller
 */
.controller("FormContactCtrl", ["$state", "$rootScope", "ConfigsDenonciations", "$uibModal", "Contacts", "ListeContacts", "toaster", "$stateParams", "$scope", "$window", "Config", "ConfigsContacts", "Membre", "CommercialisateurService", "ContactsCheck", "TransactionsClient", "DocumentsContact", "SelectionsClient", "DenoncesClient", function ($state, $rootScope, ConfigsDenonciations, $uibModal, Contacts, ListeContacts, toaster, $stateParams, $scope, $window, Config, ConfigsContacts, Membre, CommercialisateurService, ContactsCheck, TransactionsClient, DocumentsContact, SelectionsClient, DenoncesClient) {
  let self = this;
  self.showBtnContac = false;
  self.btnNextContact = false;
  self.btnPrevContact = false;
  self.btnActiverEspaceClient = false;
  self.enabledTooltipDenoncerContact = false;
  self.messageTooltipDenoncerContact = "";
  self.disabledBtnDenoncerContact = false;
  self.messageDenonciation = "";
  self.phoneRegex = /^([(]?[+]?[(]?[0-9]{1,3}[)]?)?[\s]?([0-9]{1,2}[\s.]?){5}$/;
  self.data = {
    Transactions: 0,
    Documents: 0,
    "Panier client": 0,
    Dénonciations: 0
  };

  self.$onInit = function () {
    // get total transactions
    TransactionsClient.query({
      clientId: self.contact.id,
      limit: -1,
      etat: 4,
      signature_procedure_status: "null,-20,0,10,20,30,35,40,45,50,60"
    }).$promise.then(r => {
      self.data.Transactions = r.total;
      const getCoAcq = self.contact.co_acquereur_principal ? 1 : 0;
      const hasTransactionCoAcq = r.data.filter(v => v.coclient_id != null);
      self.data["Co-acquéreurs"] = hasTransactionCoAcq.length + getCoAcq;
    }); // get total documents

    DocumentsContact.query({
      contactId: self.contact.id,
      limit: 1,
      page: 1
    }).$promise.then(r => {
      self.data.Documents = r.total;
    }); // get total selection

    SelectionsClient.query({
      contactId: self.contact.id,
      limit: 100,
      page: 1
    }).$promise.then(r => {
      self.data["Panier client"] = r.total;
    }); // get total denonciation

    DenoncesClient.query({
      contactId: self.contact.id,
      limit: 100,
      page: 1
    }).$promise.then(r => {
      self.data["Dénonciations"] = r.total;
    });
    ConfigsDenonciations.getInfosDenonciations().then(function successCallback(response) {
      self.configsDenonciations = response.data;
      self.data["Dénonciations"] = response.total;

      if (self.configsDenonciations && !self.configsDenonciations.denonciation_active) {
        self.disabledBtnDenoncerContact = true;
        self.enabledTooltipDenoncerContact = true;
        self.messageTooltipDenoncerContact = "Fonctionnalité non activée";
      }
    }, function errorCallback(response) {
      console.log("Erreur factory ConfigsDenonciations getInfosDenonciations: " + response);
      return false;
    });
    self.displayPanel = true;

    if ($stateParams.paramsNavigation) {
      self.indexContact = $stateParams.paramsNavigation.byindex;
      self.filtresContacts = $stateParams.paramsNavigation.filtresContacts;
      self.checkBtn(self.indexContact, $stateParams.paramsNavigation.total);
    }

    self.tabsData = [{
      heading: "Action/Historique",
      icon: "settings",
      route: "formContact.historique",
      disable: parseInt(self.contact.id) > 0 ? false : true
    }, {
      heading: "Transactions",
      icon: "alarm_on",
      data: self.data,
      route: "formContact.transactions",
      disable: parseInt(self.contact.id) > 0 ? false : true
    }, {
      heading: "Infos complémentaires",
      icon: "add",
      route: "formContact.infoscomplementaires",
      disable: true
    }, {
      heading: "Documents",
      icon: "folder",
      data: self.data,
      route: "formContact.documents",
      disable: parseInt(self.contact.id) > 0 ? false : true
    }, {
      heading: "Panier client",
      icon: "shopping_cart",
      data: self.data,
      route: "formContact.panier",
      disable: parseInt(self.contact.id) > 0 ? false : true
    }, {
      heading: "Co-acquéreurs",
      icon: "people",
      data: self.data,
      route: "formContact.coacquereurs",
      disable: parseInt(self.contact.id) > 0 ? false : true
    }, {
      heading: "Dénonciations",
      icon: "check",
      data: self.data,
      route: "formContact.denonciations",
      disable: parseInt(self.contact.id) > 0 ? false : true
    }, {
      heading: "Note principale ",
      icon: "comment",
      route: "formContact.note",
      disable: parseInt(self.contact.id) > 0 ? false : true
    }];
    /**
     *  Select des mois (date naissance)
     */

    self.months = moment.months();
    /**
     *  Select des années (date naissance)
     */

    self.years = [];

    for (let i = 0; i <= 200; i++) {
      const year = moment().year() - i;
      self.years.push(year);
    }

    if (self.contact && self.contact.date_naissance && self.contact.date_naissance.date) {
      const dateNaissance = moment(self.contact.date_naissance.date);
      self.date_naissance = {};
      self.date_naissance.day = dateNaissance.get("date").toString();
      self.date_naissance.month = dateNaissance.get("month").toString();
      self.date_naissance.year = dateNaissance.get("year").toString();
    }

    self.titleFormContact = self.contact.id ? "Édition d'un contact" : "Créer un nouveau contact";
    self.listGroupesAvancementsView = [];
    angular.forEach(self.listGroupesAvancements, function (value, key) {
      angular.forEach(self.listAvancements, function (v, k) {
        if (v.groupe_avancement_id === value.id) {
          self.listGroupesAvancementsView.push({
            groupe_avancement_id: value.id,
            groupe_avancement_label: value.label,
            avancement_id: v.id,
            avancement_label: v.label
          });
        }
      });
    });

    if (self.contact && self.contact.id) {
      if (self.contact.email && self.contact.email.length > 0) {
        self.showBtnContac = true;
      }

      if (self.contact.image !== undefined) {
        self.file = self.contact.image;
      }

      self.getUpdateAvancement(self.contact.avancement_id);

      if (self.contact.denonciation_vendeur_id) {
        Membre.get({
          membreId: self.contact.denonciation_vendeur_id
        }).$promise.then(function (response) {
          self.denonciation_vendeur = response;
          return true;
        }).catch(function (err) {
          console.log("promise error", err);
        });
      }
    }
  };

  self.uploadFiles = function (file, errFiles) {
    self.contact.setProfilImage(file);
  };

  self.goPanier = function (contactId) {
    $state.go("formContact.panier", {
      contactId: contactId
    });
  };

  self.nextContact = function () {
    let nextIndex = parseInt(self.indexContact) + 1;
    self.filtresContacts.range = nextIndex + "-" + nextIndex;
    Contacts.query(self.filtresContacts).$promise.then(function (response) {
      if (nextIndex < parseInt(response.total)) {
        $state.go("formContact.historique", {
          contactId: response.data[0].id,
          paramsNavigation: {
            contactId: response.data[0].id,
            byindex: nextIndex,
            total: response.total,
            filtresContacts: self.filtresContacts
          }
        });
      }

      self.checkBtn(self.indexContact, response.total);
    }).catch(function (err) {
      console.log("promise error", err);
    });
  };

  self.getUpdateAvancement = function (avancementId) {
    angular.forEach(self.listGroupesAvancementsView, function (value, key) {
      if (avancementId == value.avancement_id) {
        self.groupe_avancement_id = value.groupe_avancement_id;
      }
    });
  };

  self.setAvancement = function (avancementId) {
    const groupAvancement = self.listGroupesAvancementsView.find(x => x.avancement_id === avancementId);

    if (!groupAvancement) {
      return;
    }

    self.contact.avancement_id = groupAvancement.avancement_id;
    self.groupe_avancement_id = groupAvancement.groupe_avancement_id;
    Contacts.update({
      id: self.contact.id,
      avancement_id: self.contact.avancement_id,
      groupe_avancement_id: self.groupe_avancement_id
    });
  };

  self.prevContact = function () {
    let prevIndex = parseInt(self.indexContact) - 1;
    self.filtresContacts.range = prevIndex + "-" + prevIndex;
    Contacts.query(self.filtresContacts).$promise.then(function (response) {
      if (prevIndex >= 0) {
        $state.go("formContact.historique", {
          contactId: response.data[0].id,
          paramsNavigation: {
            contactId: response.data[0].id,
            byindex: prevIndex,
            total: response.total,
            filtresContacts: self.filtresContacts
          }
        });
      }

      self.checkBtn(self.indexContact, response.total);
    }).catch(function (err) {
      console.log("promise error", err);
    });
  };

  self.checkContactBeforeSave = () => {
    if (self.contact.id) {
      return self.save();
    } else {
      return ContactsCheck.query(self.contact).$promise.then(response => {
        let homonyme = ["Nom", "Prenom"];

        if (response.type && response.type === "contact_denonce") {
          const bodyMessageContactDenonce = response.contact ? `Création impossible. Ce contact est déjà dénoncé par ${response.contact.commercialisateur_nom} jusqu'au ${moment(response.contact.date_fin.date).format("DD/MM/YYYY")}` : response.message;
          toaster.pop({
            type: "error",
            body: bodyMessageContactDenonce
          });
          return;
        } // Forcer la creation contact pour les homonyme
        else if (response.message && JSON.stringify(response.message) == JSON.stringify(homonyme)) {
            toaster.pop({
              type: "Infos",
              title: "Infos",
              body: "Attention un contact exsite déjà avec les mêmes Nom et Prénom"
            });
          } else if (response.contact) {
            const list = response.message.join(", ");
            toaster.pop({
              type: "Infos",
              title: "Infos",
              body: `Le contact existe avec le(s) même(s) : ${list} chez ${response.contact.commercialisateur_nom}`
            });
            return;
          }

        return self.save();
      });
    }
  };

  self.save = function () {
    /**
     * set du pays
     */
    self.contact.pays = self.countrySelected.id;
    /**
     * Construction de la date naissance
     */

    if (self.date_naissance && self.date_naissance.day && self.date_naissance.month && self.date_naissance.year) {
      const dateNaissance = moment().year(self.date_naissance.year).month(self.date_naissance.month).date(self.date_naissance.day).format("YYYY-MM-DD") + " 00:00:00";
      self.contact.date_naissance = dateNaissance;
    }

    if (!self.contact.preferences_programme_venir) {
      self.contact.preferences_programme_venir = false;
    }

    if (self.contact.id) {
      return self.contact.createOrUpdate().then(() => {
        toaster.pop({
          type: "success",
          title: "",
          body: "Votre contact a bien été modifié"
        });
        $state.go($state.current, {
          contactId: self.contact.id
        }, {
          reload: true
        });
      });
    } else {
      return self.contact.createOrUpdate().then(response => {
        self.contact = response;
        toaster.pop({
          type: "success",
          title: "",
          body: "Votre contact a bien été créé"
        });
        $state.go($state.current, {
          contactId: self.contact.id
        }, {
          reload: true
        });
      }).catch(error => {
        toaster.pop({
          type: "error",
          title: "Attention",
          body: error,
          timeout: 10000
        });
      });
      angular.forEach(self.tabsData, function (value, key) {
        if (value.disable === true) {
          value.disable = false;
        }
      });
    }
  };

  self.checkBtn = function (index, total) {
    if (parseInt(index) + 1 === parseInt(total)) {
      self.btnNextContact = true;
    }

    if (parseInt(index) === 0) {
      self.btnPrevContact = true;
    }
  };

  self.getMessageDenonciation = function (membreConnecter) {
    if (membreConnecter && membreConnecter.is_admin && self.denonciation_vendeur && self.contact.denonciation_statut_id === 2) {
      self.messageDenonciation = "Contact dénoncé par " + self.denonciation_vendeur.nom + " " + self.denonciation_vendeur.prenom + " du <br> <strong>" + moment(self.contact.denonciation_date_debut.date).format("DD/MM/YYYY") + " </strong> au <strong> " + moment(self.contact.denonciation_date_fin.date).format("DD/MM/YYYY") + " </strong> ";
      return true;
    } else if (membreConnecter && self.denonciation_vendeur && membreConnecter.id === self.denonciation_vendeur.id && self.contact.denonciation_statut_id === 2) {
      self.messageDenonciation = "Contact dénoncé du <br> <strong>" + moment(self.contact.denonciation_date_debut.date).format("DD/MM/YYYY") + " </strong> au <strong> " + moment(self.contact.denonciation_date_fin.date).format("DD/MM/YYYY") + " </strong> ";
      return true;
    }

    return false;
  };

  self.retour = function () {
    let filtres = angular.copy(self.filtresContacts);

    if (filtres && filtres.range) {
      delete filtres.range;
    }

    $state.go("mesContacts", {
      filtres: filtres
    });
  };

  self.checkTest = function () {
    self.placeholderTelMobile = "Téléphone mobile";
    self.placeholderEmail = "Email"; //console.log(self.contact);

    if (!self.contact.tel_mobile && !self.contact.email) {
      self.placeholderTelMobile += " *";
      self.placeholderEmail += " *";
      return true;
    }

    return false;
  };
  /*
   * Modal openModalContact
   */


  self.openModalContact = function () {
    ListeContacts.setListeContacts([self.contact]);
    let modalInstance = $uibModal.open({
      windowTemplateUrl: "templates/modal/modal-window-lg.html",
      templateUrl: "contacter-contacts/modal-contacter-contacts.html",
      controller: "ContacterContactsCtrl",
      controllerAs: "$ctrl"
    });
    modalInstance.result.then(function (selectedItem) {
      self.selected = selectedItem;
    });
  };
  /*
   * Modal openModalDenonciation
   */


  self.openModalDenonciation = function () {
    let modalInstance = $uibModal.open({
      templateUrl: "denoncer-contact/modal-denoncer-contact.html",
      controller: "DenoncerContactModalCtrl",
      controllerAs: "$ctrl",
      resolve: {
        contact: function () {
          return self.contact;
        },
        configDenonciations: function () {
          return ConfigsDenonciations.getInfosDenonciations().then(function (response) {
            return response;
          });
        }
      }
    });
  };
  /*
   * Modal openModalConfirmation
   */


  self.openModalConfirmation = function () {
    let modalInstance = $uibModal.open({
      templateUrl: "form-contact/modal-confirmation.html",
      controller: "ConfirmerModalCtrl",
      controllerAs: "$ctrl",
      resolve: {
        contact: function () {
          return self.contact;
        }
      }
    });
    modalInstance.result.then(function (selectedItem) {
      self.selected = selectedItem;
    });
  };
  /*
   * Modal openModalConfirmation
   */


  self.openModalConfirmation = function (trans) {
    let modalInstance = $uibModal.open({
      templateUrl: "form-contact/modal-confirmation.html",
      controller: "ConfirmerModalCtrl",
      controllerAs: "$ctrl",
      resolve: {
        trans: function () {
          return trans;
        }
      }
    });
    modalInstance.result.then(function (selectedItem) {
      self.selected = selectedItem;
    });
  };

  self.range = (min, max, step) => {
    step = step || 1;
    const input = [];

    for (let i = min; i <= max; i += step) {
      input.push(i);
    }

    return input;
  };

  $scope.ctrlDown = false;
  $scope.ctrlKey = 17;

  $rootScope.keyDownFunc = function ($event) {
    if ($scope.ctrlDown && String.fromCharCode($event.which).toLowerCase() == "s") {
      $event.preventDefault();
      self.save();
    }
  };

  angular.element($window).bind("keyup", function ($event) {
    if ($event.keyCode == $scope.ctrlKey) {
      $scope.ctrlDown = false;
    }

    $scope.$apply();
  });
  angular.element($window).bind("keydown", function ($event) {
    if ($event.keyCode == $scope.ctrlKey) {
      $scope.ctrlDown = true;
    }

    $scope.$apply();
  });
}]).controller("FormContactContactCtrl", ["contact", "$uibModal", "$rootScope", function (contact, $uibModal, $rootScope) {
  let self = this;
  self.contact = contact;
  self.cContact = angular.copy(self.contact);
  /*
   * Modal newAction
   */

  self.newAction = function () {
    $uibModal.open({
      templateUrl: "crm/action/modal-form-action.html",
      controller: "actionModalCtrl",
      controllerAs: "$ctrl",
      resolve: {
        contact: function () {
          return self.contact;
        },
        actionId: function () {
          return false;
        }
      }
    }).result.then(a => {
      $rootScope.$broadcast("newAction", {
        contact: self.contact,
        action: a
      });
    });
  };
}]).controller("FormContactMinCtrl", ["$scope", function ($scope) {
  let self = this;
  self.phoneRegex = /^([(]?[+]?[(]?[0-9]{1,3}[)]?)?[\s]?([0-9]{1,2}[\s.]?){5}$/; // self.$postLink = function () {
  //   self.myForm = self.formContact;
  // };
}]).controller("FormContactBesoinCtrl", ["$state", "$filter", "$scope", "moment", "ConfigsProgrammes", "ConfigsLots", "ConfigsCommercialisateurs", "toaster", function ($state, $filter, $scope, moment, ConfigsProgrammes, ConfigsLots, ConfigsCommercialisateurs, toaster) {
  let self = this;
  self.selectedPreferencesPeriodeAchat = selectedPreferencesPeriodeAchat;
  self.labelMultiSelect = {
    itemsSelected: "éléments sélectionnés",
    selectAll: "Tout sélectionner",
    unselectAll: "Tout déselectionner",
    search: "Chercher"
  };

  self.$onInit = function () {
    if (self.contact && !self.contact.preferences_ville_rayon) {
      self.contact.preferences_ville_rayon = 10;
    }

    self.sliderVilleSouhaitRayonOptions = {
      id: "sliderRayon",
      floor: 10,
      ceil: 50,
      step: 5,
      hidePointerLabels: true,
      disabled: !self.contact.preferences_ville
    };
    self.labelVilleSouhaitee = self.contact.preferences_ville && self.contact.preferences_code_postal ? `${self.contact.preferences_ville} (${self.contact.preferences_code_postal})` : "";
    ConfigsProgrammes.getProgrammes({
      etat: "1,2,3,6",
      limit: -1,
      statut: "0,1,2",
      sort: "nom",
      programme_allowed: true,
      programme_non_dispo: true
    }).then(function successCallback(response) {
      self.listProgrammes = response.data.data;
    }, function errorCallback(response) {
      console.log("Erreur factory Programmes get programmes " + response);
      return false;
    });
    ConfigsLots.getTypes().then(function successCallback(response) {
      self.listTypes = response.data;
    }, function errorCallback(response) {
      console.log("Erreur factory ConfigsLots getTypes : " + response);
      return false;
    });
    ConfigsLots.getPrix().then(function successCallback(response) {
      self.listLotsPrix = response.data;
      min = response.data.prix_min ? parseInt(response.data.prix_min) : 1;
      max = response.data.prix_max ? parseInt(response.data.prix_max) : 2100000;
      self.sliderbudget = {
        min: initMinMaxSlider(self.contact.preferences_min_prix, min),
        max: initMinMaxSlider(self.contact.preferences_max_prix, max),
        options: {
          id: "sliderBudget",
          floor: Math.ceil(min),
          ceil: max,
          pushRange: true,
          hidePointerLabels: true,
          onChange: setValueSliderBudget,
          translate: function (value) {
            return $filter("currency")(value, self.listLotsPrix.unite, 0);
          }
        },
        onStart: refreshSlider()
      };
    }, function errorCallback(response) {
      console.log("Erreur factory ConfigsLots getPrix : " + response);
      return false;
    });
    ConfigsLots.getSurfaces().then(function successCallback(response) {
      self.listSurfaces = response.data;
      min = response.data.surface_min ? parseInt(response.data.surface_min) : 0;
      max = response.data.surface_max ? parseInt(response.data.surface_max) : 500;
      self.slidersurfaces = {
        min: initMinMaxSlider(self.contact.preferences_min_surface, min),
        max: initMinMaxSlider(self.contact.preferences_max_surface, max),
        options: {
          id: "sliderSurfacse",
          floor: min,
          ceil: max,
          hidePointerLabels: true,
          pushRange: true,
          onChange: setValueSliderSurfaces,
          translate: function (value) {
            return value + " m<sup>2</sup>";
          }
        },
        onStart: refreshSlider()
      };
    }, function errorCallback(response) {
      console.log("Erreur factory ConfigsLots getSurfaces : " + response);
      return false;
    });
    ConfigsProgrammes.getVilles().then(function successCallback(response) {
      self.listVilles = response.data;
    }, function errorCallback(response) {
      console.log("Erreur factory ConfigsProgrammes getVilles : " + response);
      return false;
    });
    ConfigsLots.getEtages().then(function successCallback(response) {
      self.listEtages = response.data;
    }, function errorCallback(response) {
      console.log("Erreur factory ConfigsLots getEtages : " + response);
      return false;
    });
    ConfigsCommercialisateurs.getFiscalites().then(function successCallback(response) {
      self.listDispositifFiscal = response.data;
    }, function errorCallback(response) {
      console.log("Erreur factory ConfigsLots getFiscalites : " + response);
      return false;
    });
    let prefPeriodeAchat = self.contact.complement_date_periode_achat ? self.contact.complement_date_periode_achat : undefined;

    if (prefPeriodeAchat) {
      selectedPreferencesPeriodeAchat(prefPeriodeAchat);
    }

    self.tabPeriodeAchat = getQuarter(prefPeriodeAchat, 5);
  };

  self.trouverBiensCorrespondants = () => {
    if (!self.contact.preferences_programme_venir) {
      self.contact.preferences_programme_venir = false;
    }

    if (self.contact.id) {
      return self.contact.createOrUpdate().then(() => {
        toaster.pop({
          type: "success",
          title: "",
          body: "Votre contact a bien été modifié"
        });
        $state.go("rechercheBiens", {
          id: self.contact.id
        });
      });
    }
  };

  function getQuarter(contactPreferences, nbYears) {
    let tabReturn = [];
    let currentQuarter = moment().quarter();
    let currentYear = moment().format("YYYY");

    if (contactPreferences) {
      let quarterPreferencesPeriodeAchat = parseInt(moment(contactPreferences.date).quarter());
      let yearPreferencesPeriodeAchat = parseInt(moment(contactPreferences.date).format("YYYY"));

      if (yearPreferencesPeriodeAchat < currentYear) {
        tabReturn.push(getQuarterRange(quarterPreferencesPeriodeAchat, yearPreferencesPeriodeAchat));
      }
    }

    for (var q = currentQuarter; q <= 4; q++) {
      tabReturn.push(getQuarterRange(q, parseInt(currentYear)));
    }

    for (let y = 1; y <= nbYears; y++) {
      for (var q = 1; q <= 4; q++) {
        tabReturn.push(getQuarterRange(q, parseInt(currentYear) + y));
      }
    }

    return tabReturn;
  }

  function getQuarterRange(quarter, year) {
    let start = moment({
      year: year
    }).quarter(quarter).startOf("quarter");
    let end = moment({
      year: year
    }).quarter(quarter).endOf("quarter").format("DD/MM/YYYY");
    let label = quarter === 1 ? quarter + "er trimestre " + year : quarter + "eme trimestre " + year;
    let value = start.format("YYYY-MM-DD");
    start = start.format("DD/MM/YYYY");
    return {
      start,
      end,
      year,
      label,
      value
    };
  }

  function selectedPreferencesPeriodeAchat(date) {
    if (date) {
      if (date.date) {
        date = date.date;
      }

      let selectQuarter = moment(date).quarter();
      let selectYear = moment(date).format("YYYY");
      let quarterRange = getQuarterRange(selectQuarter, selectYear);
      self.contact.complement_date_periode_achat = moment(date).format("YYYY-MM-DD");
      self.labelSelectedPreferencesPeriodeAchat = "du " + quarterRange.start + " au " + quarterRange.end;
    }
  }

  function setValueSliderBudget(str, min, max) {
    self.changeParamsTrouverBiensCorrespondants = true;
    self.contact.preferences_min_prix = parseInt(min);
    self.contact.preferences_max_prix = parseInt(max);
  }

  function setValueSliderSurfaces(str, min, max) {
    self.changeParamsTrouverBiensCorrespondants = true;
    self.contact.preferences_min_surface = parseInt(min);
    self.contact.preferences_max_surface = parseInt(max);
  }

  function initMinMaxSlider(valeur, valeurDefault) {
    if (valeur !== null && valeur !== undefined) {
      return Math.ceil(valeur);
    } else {
      return Math.ceil(valeurDefault);
    }
  }

  function refreshSlider() {
    setTimeout(function () {
      $scope.$broadcast("rzSliderForceRender");
    }, 800);
  }

  $scope.$watch(() => {
    return this.villeSelected;
  }, val => {
    if (typeof val == "undefined") {
      return;
    }

    this.contact.preferences_ville = val && val.nom ? val.nom : "";
    this.contact.preferences_code_postal = val && val.codePostal ? val.codePostal : "";
    this.contact.preferences_lat = val && val.coordinates ? val.coordinates[1] : "";
    this.contact.preferences_lng = val && val.coordinates ? val.coordinates[0] : ""; // Enabled/Disabled slider if ville souhaitée selected/empty

    this.sliderVilleSouhaitRayonOptions.disabled = this.contact.preferences_ville.length === 0;
  }, true);
}]).controller("ConfirmerModalCtrl", ["$uibModalInstance", "$state", "$rootScope", "trans", function ($uibModalInstance, $state, $rootScope, trans) {
  let $ctrl = this;

  $ctrl.valider = function () {
    $rootScope.isTransitionsValider = true;
    $uibModalInstance.close();
    $state.go(trans._targetState._identifier, trans._targetState.params);
  };

  $ctrl.annuler = function () {
    $uibModalInstance.close();
  };
}]);
/**
 * Module definition and dependencies
 */

angular.module('Crm.FormContact', ['Crm.FormContact.Controller', 'Crm.form-contact.templates']).component('formContactBesoin', {
  controller: 'FormContactBesoinCtrl',
  templateUrl: 'src/form-contact/tabs/besoin.html',
  bindings: {
    contact: '<'
  }
}).component('formContact', {
  controller: 'FormContactCtrl',
  templateUrl: 'src/form-contact/form-contact.html',
  bindings: {
    contact: '<',
    listOrigines: '<',
    listSources: '<',
    listEtages: '<',
    listAvancements: '<',
    listGroupesAvancements: '<',
    configCommercialisateurs: '<'
  }
}).component('formContactMin', {
  controller: 'FormContactMinCtrl',
  templateUrl: 'src/form-contact/form-contact-min.html',
  bindings: {
    contact: '<',
    showsubmitbtn: '<',
    formContact: '='
  }
});
angular.module('Crm.form-contact.templates', []).run(['$templateCache', function($templateCache) {$templateCache.put('src/form-contact/form-contact-min.html','<form name="$ctrl.formContact" class="relative" novalidate><div class="row--sm"><div class="col-xs-6 col-md-3"><div class="form-group"> <label>Civilit\xE9</label><div class="form-group--select"> <i class="material-icons">arrow_drop_down</i> <select class="form-control" name="civilite" ng-model="$ctrl.contact.civilite" ng-readonly="$ctrl.readOnlyForm"><option value="">Civ.</option><option value="M" label="M.">M.</option><option value="F" label="Mme">Mme</option><option value="MF" label="M. et Mme">M. et Mme</option></select></div></div></div><div class="col-xs-12 col-md-9"><div class="form-group"> <label>Nom *</label> <input class="form-control" name="nom" type="text" ng-model="$ctrl.contact.nom" ng-required="true" required ng-readonly="$ctrl.readOnlyForm"/></div></div><div class="col-xs-12 col-md-9 col-md-offset-3"><div class="form-group"> <label>Pr\xE9nom *</label> <input class="form-control" name="prenom" type="text" ng-model="$ctrl.contact.prenom" ng-required="true" required ng-readonly="$ctrl.readOnlyForm"/></div></div><div class="col-xs-12"><div class="form-group"> <label>Adresse</label> <input class="form-control" name="adresse1" type="text" ng-model="$ctrl.contact.adresse1" ng-readonly="$ctrl.readOnlyForm"/></div></div><div class="col-xs-12"><div class="form-group"> <input class="form-control" name="adresse2" type="text" ng-model="$ctrl.contact.adresse2" ng-readonly="$ctrl.readOnlyForm"/></div></div><div class="col-xs-12 col-md-4"><div class="form-group"> <label>CP</label> <input class="form-control" name="cp" type="text" ng-model="$ctrl.contact.cp" ng-readonly="$ctrl.readOnlyForm"/></div></div><div class="col-xs-12 col-md-8"><div class="form-group"> <label>Ville</label> <input class="form-control" name="ville" type="text" ng-model="$ctrl.contact.ville" ng-readonly="$ctrl.readOnlyForm"/></div></div><div class="col-xs-12 col-md-6"><div class="form-group"> <label>T\xE9l\xE9phone *</label> <input class="form-control" name="tel" type="text" ng-model="$ctrl.contact.tel" ng-required="true" required ng-pattern="$ctrl.phoneRegex" ng-readonly="$ctrl.readOnlyForm"/></div></div><div class="col-xs-12 col-md-6"><div class="form-group"> <label>T\xE9l\xE9phone mobile *</label> <input class="form-control" name="tel_mobile" type="text" ng-required="true" ng-model="$ctrl.contact.tel_mobile" ng-readonly="$ctrl.readOnlyForm"/></div></div><div class="col-xs-12 col-md-6"><div class="form-group"> <label>T\xE9l\xE9phone bureau</label> <input class="form-control" name="tel_bureau" type="text" ng-model="$ctrl.contact.tel_bureau" ng-pattern="$ctrl.phoneRegex" ng-readonly="$ctrl.readOnlyForm"/></div></div><div class="col-xs-12"><div class="form-group"> <label>Email *</label> <input class="form-control" name="email" type="email" ng-model="$ctrl.contact.email" ng-required="true" required ng-readonly="$ctrl.readOnlyForm"/></div></div></div></form>');
$templateCache.put('src/form-contact/form-contact.html','<div class="top-pager" id="top"><div class="row"><div class=" col-xs-12"><nav aria-label="..." class="d-flex align-center j-space-between w-100"><div class="hidden-xs"> <a ng-click="$ctrl.retour()" class="btn-primary btn-xs btn ">Retour</a><div class="nav-contact"> <button class="btn-primary btn-xs btn" ng-click="$ctrl.prevContact()" ng-disabled="$ctrl.btnPrevContact" ng-class="{[\'btn-disabled\']: $ctrl.btnPrevContact}" ng-if="$ctrl.filtresContacts"><small><i class="glyphicon glyphicon-chevron-left"></i></small></button> <button class="btn-primary btn-xs btn" ng-click="$ctrl.nextContact()" ng-disabled="$ctrl.btnNextContact" ng-class="{[\'btn-disabled\']: $ctrl.btnNextContact}" ng-if="$ctrl.filtresContacts"><small><i class="glyphicon glyphicon-chevron-right"></i></small></button></div></div><div class="arrow_mobile hidden-lg hidden-md hidden-sm d-flex"><div> <button class=" btn-xs btn" ng-click="$ctrl.prevContact()" ng-disabled="$ctrl.btnPrevContact" ng-class="{[\'btn-disabled\']: $ctrl.btnPrevContact}" ng-if="$ctrl.filtresContacts"> <span>Prec.</span></button></div><div> <button class=" btn-xs btn" ng-click="$ctrl.nextContact()" ng-disabled="$ctrl.btnNextContact" ng-class="{[\'btn-disabled\']: $ctrl.btnNextContact}" ng-if="$ctrl.filtresContacts"> <span>Suiv.</span></button></div></div></nav></div></div></div><form name="formContact" class="relative mt-0" novalidate unsaved-warning-form><div class="card hovercard smooth h-100"><div class="cardheader d-flex align-center"><div class="row"><div class="visible-xs"><div class="col-xs-12 pa-15" ng-if="$ctrl.contact.id"><div class=" pull-left text-left d-flex align-center mt-1 mb-05"> <i class="material-icons settings">settings</i> <span style="margin-left : 0.2rem;">Prochaine action</span></div></div><div class="col-xs-12 form-contact-actions mb-1 pa-15" ng-if="$ctrl.contact.id"><mes-actions-route contact-id="$ctrl.contact.id"></mes-actions-route></div><div class="col-xs-12 mb-1 pa-15"> <button ui-sref="formContact.panier" class="w-100 btn btn-tertiary btn-sm mb-05">Voir la s\xE9lection</button><ecrire-btn contacts-selectionner="[$ctrl.contact]" disabled="true" add-class="\'w-100 btn btn-tertiary btn-sm\'" ng-if="$root.configsCommercialisateurs.messagerie_desactiver === false"></ecrire-btn></div></div></div></div><div class="panel-footer hidden-lg hidden-md hidden-sm"> <span ng-show="!$ctrl.displayPanel" ng-click="$ctrl.displayPanel = true"><i class="material-icons">add</i> Voir le d\xE9tail</span> <span ng-show="$ctrl.displayPanel" ng-click="$ctrl.displayPanel = false"><i class="material-icons">remove</i>Masquer le d\xE9tail</span></div><div class="panel-body " ng-class="$ctrl.displayPanel == false ? \'hidden-xs\' : \'\'"><div class="d-flex panel-content"><div class="border-right d-grid"><div class="row--sm"><div class="col-xs-3 col-sm-3 col-md-3"><div class="avatar col-avatar" ng-if="$ctrl.contact.image"><div class="bg-img" ngf-background="$ctrl.contact.image" style="background-size:cover; background-position:center;background-repeat: no-repeat;background-color:#fff;"></div> <button type="file" class="btn btn--photo" accept="image/*" ngf-select="$ctrl.uploadFiles($file, $invalidFiles)" ngf-resize-if="$width > 200 || $height > 200" ngf-resize="{width: 200, quality: .8, type: \'image/jpeg\'}" ngf-max-height="5500" ngf-fix-orientation="true" ngf-max-size="8MB"> <i class="material-icons">linked_camera</i></button></div><div class="avatar col-avatar" ng-if="!$ctrl.contact.image"><div class="bg-img" ngf-background="$ctrl.contact.image" style="background-size:cover; background-position:center;background-repeat: no-repeat;background-color:#fff;"></div> <i class="material-icons profil-icon">person</i> <button type="file" class="btn btn--photo" accept="image/*" ngf-select="$ctrl.uploadFiles($file, $invalidFiles)" ngf-resize-if="$width > 200 || $height > 200" ngf-resize="{width: 200, quality: .8, type: \'image/jpeg\'}" ngf-max-height="5500" ngf-fix-orientation="true" ngf-max-size="8MB"> <i class="material-icons">linked_camera</i></button></div> <input type="hidden" ng-model="$ctrl.contact.image"/></div><div class="col-xs-9 col-sm-9 col-md-9 mb-0"><div class="col-title text-left"><h3>Identit\xE9<i class="fa fa-caret-right"></i></h3></div></div></div><div class="row--sm" style="margin-top:-10px"><div class="col-sm-12 col-md-6"><div class="form-group m-0 text-left" ng-messages="formContact.nom.$error"> <label>Nom</label> <input placeholder="Nom *" class="form-control" name="nom" type="text" ng-model="$ctrl.contact.nom"/></div></div><div class="col-sm-12 col-md-6"><div class="form-group m-0 text-left" ng-messages="formContact.prenom.$error"> <label>Pr\xE9nom</label> <input placeholder="Pr\xE9nom" class="form-control" name="pr\xE9nom" type="text" ng-model="$ctrl.contact.prenom"/></div></div></div><div class="row--sm"><div class="col-sm-12 col-xs-12 col-md-6"><div class="form-group m-0 text-left" ng-messages="formContact.tel_mobile.$error"> <label class="">Mobile</label><div class="input-group"> <span class="input-group-addon"><span ng-if="$ctrl.countrySelected.tel">+{{ $ctrl.countrySelected.tel }}</span></span> <input class="form-control" type="text" ng-pattern="$ctrl.phoneRegex" placeholder="{{ $ctrl.placeholderTelMobile }}" ng-model="$ctrl.contact.tel_mobile" ng-required="$ctrl.checkTest()"/></div></div></div><div class="col-sm-12 col-xs-12 col-md-6"><div class="form-group m-0 text-left" ng-messages="formContact.tel.$error"> <label class="">Fixe</label><div class="input-group"> <span class="input-group-addon"><span ng-if="$ctrl.countrySelected.tel">+{{ $ctrl.countrySelected.tel }}</span></span> <input class="form-control" type="text" ng-model="$ctrl.contact.tel" ng-pattern="$ctrl.phoneRegex"/></div></div></div></div><div class="row--sm"><div class="col-sm-12 col-xs-12 col-md-6"><div class="form-group mb-1 text-left" ng-messages="formContact.tel_bureau.$error"> <label class="">Bureau</label><div class="input-group"> <span class="input-group-addon"><span ng-if="$ctrl.countrySelected.tel">+{{ $ctrl.countrySelected.tel }}</span></span> <input class="form-control" type="text" ng-pattern="$ctrl.phoneRegex" ng-model="$ctrl.contact.tel_bureau"/></div></div></div><div class="col-sm-12 col-xs-12 col-md-6"><div class="form-group mb-0 text-left" ng-messages="formContact.email.$error"> <label>Email</label> <input class="form-control" name="email" type="email" ng-model="$ctrl.contact.email" placeholder="{{ $ctrl.placeholderEmail }}" ng-required="$ctrl.checkTest()"/></div></div></div><div class="row--sm"><div class="col-sm-12 col-md-12"><div class="form-group text-left"> <label>Adresse</label> <input class="form-control" name="adresse1" type="text" ng-model="$ctrl.contact.adresse1"/></div></div><div class="col-sm-12 col-md-12"><div class="form-group"> <input class="form-control" name="adresse2" type="text" ng-model="$ctrl.contact.adresse2"/></div></div><div class="col-sm-12 col-md-3"><div class="form-group"> <input placeholder="CP" class="form-control" name="cp" type="text" ng-model="$ctrl.contact.cp"/></div></div><div class="col-sm-5"><div class="form-group"> <input placeholder="Ville" class="form-control" name="ville" type="text" ng-model="$ctrl.contact.ville"/></div></div><div class="col-12 col-md-4"><div class="form-group"><country country-id="$ctrl.contact.pays" country="$ctrl.countrySelected" params="{active: 1}"></country></div></div></div><div class="clearfix"></div><div class="row--sm text-left"><div class="col-sm-12 col-md-12 mt-1"><div class="deploy-btn contact-infos-toogle"><label for="deploy-contact-info">Plus d\'infos<i class="fa fa-chevron-down"></i></label></div> <input type="checkbox" id="deploy-contact-info"/><div class="contact-infos-content"><div class="row--sm text-left"><div class="col-sm-12"> <label>Date de naissance</label></div></div><div class="row--sm text-left"><div class="col-sm-12 col-md-2"><div class="form-group"> <select class="form-control" ng-model="$ctrl.date_naissance.day"><option value="">Jour</option><option ng-repeat="day in $ctrl.range(1,31)" value="{{ day }}">{{ day }}</option></select></div></div><div class="col-sm-12 col-md-3"><div class="form-group"> <select class="form-control capitalize" ng-model="$ctrl.date_naissance.month"><option value="">Mois</option><option ng-repeat="month in $ctrl.months" value="{{ $index }}">{{ month }}</option></select></div></div><div class="col-sm-12 col-md-3"><div class="form-group"> <select class="form-control" ng-model="$ctrl.date_naissance.year"><option value="">Ann\xE9e</option><option ng-repeat="year in $ctrl.years" value="{{ year }}">{{ year }}</option></select></div></div></div><div class="row--sm"><div class="col-12 col-md-8"><div class="form-group mb-1 text-left"> <label class="">Bailleur</label><div class="input-group w-100"> <input class="form-control" type="text" ng-model="$ctrl.contact.complement_informations_bailleur"/></div></div></div><div class="col-12 col-md-4"><div class="mt-2 mb-1 txt-left"> <input type="checkbox" id="complement_locataire_hlm" ng-model="$ctrl.contact.complement_locataire_hlm"/> <label for="complement_locataire_hlm" class="checkbox">Locataire HLM</label></div></div></div></div></div></div><div id="contact-action" class="row--sm " ng-if="$ctrl.contact.id"><div class="col-lg-12"><div class="text-left contact-action-title mt-1 mb-05"> <span><b>Prochaine ACTION :</b></span></div></div><div class="col-lg-12 col-sm-12 col-md-6 form-contact-actions"><mes-actions-route contact-id="$ctrl.contact.id"></mes-actions-route></div></div><div class="row--sm text-left d-grid align-end btn-ecrire-wrap justify-end" style="padding:0 7.5px"><ecrire-btn contacts-selectionner="[$ctrl.contact]" disabled="true" add-class="\'btn btn-tertiary btn-sm btn-radius mt-1 w-140\'"></ecrire-btn></div></div><div class="border-right"><form-contact-besoin contact="$ctrl.contact" add-class="d-flex"></form-contact-besoin></div><div class="d-grid content-between"><div><div class="row--sm text-left"><div class="col-xs-2 col-md-2"></div><div class="col-xs-12 col-md-10"><div class="col-title text-left"><h3>Avancement<i class="fa fa-caret-right"></i></h3></div></div><div class="clearfix"></div><div class="col-xs-12 col-md-6"> <label>Avancement commercial</label><div class="form-group--select"> <i class="material-icons">arrow_drop_down</i> <select class="groupe-avancement-color-{{ $ctrl.groupe_avancement_id }} form-control" ng-model="$ctrl.contact.avancement_id" ng-change="$ctrl.getUpdateAvancement($ctrl.contact.avancement_id)" ng-options="item.avancement_id as item.avancement_label group by item.groupe_avancement_label for item in $ctrl.listGroupesAvancementsView"></select></div></div><div class="col-xs-12 col-md-6"><div admin-only> <label>Attribution du contact</label><select-vendeur title-select="\'S\xE9lectionner un vendeur\'" reload="false" no-save="true" vendeur-selected="$ctrl.contact.vendeur_id"></select-vendeur></div></div></div><div class="row--sm text-left"><div class="col-xs-12 col-md-12"><div class="form-group text-left m-0"> <label>Origine</label><div class="form-group--select"> <i class="material-icons">arrow_drop_down</i> <select name="complement_origine" class="form-control" ng-model="$ctrl.contact.complement_origine" ng-options="origine.id as origine.label for origine in $ctrl.listOrigines"><option value="" selected="selected">Origine</option></select><div ng-messages="formContact.complement_origine.$error"></div></div></div></div><div class="col-xs-12 col-md-12"><div class="form-group text-left m-0"> <label>Source</label><div class="form-group--select"> <i class="material-icons">arrow_drop_down</i> <select name="complement_source" class="form-control" ng-model="$ctrl.contact.complement_source" ng-options="source.id as source.label for source in $ctrl.listSources"><option value="">Source</option></select></div></div></div><div class="col-xs-12 col-md-12"><div class="form-group text-left" ng-if="$ctrl.contact.complement_message_client"> <label>Message client</label> <textarea class="w-100" rows="5" readonly>{{ $ctrl.contact.complement_message_client }}</textarea></div><div class="text-left" ng-if="$ctrl.contact.date_creation.date"> <label>Date de cr\xE9ation : {{ $ctrl.contact.date_creation.date | moment: "DD/MM/YYYY" }}</label></div></div></div></div><div><div class="clearfix"></div><div class="row--sm text-left"><div class="col-xs-12 col-md-6"> <button class="btn btn-tertiary btn-radius btn-sm mt-1 w-100 ng-scope" ng-click="$ctrl.openModalDenonciation()" ng-disabled="$ctrl.disabledBtnDenoncerContact"> D\xE9noncer ce contact</button></div><div class="col-xs-12 col-md-6"><espace-client client="$ctrl.contact"></espace-client></div><div class="col-xs-12 col-md-6"> <button class="btn btn-tertiary btn-radius btn-sm mt-1 w-100 ng-scope" ng-click="$ctrl.setAvancement(6)"> Classer sans suite</button></div><div class="col-xs-12 col-md-6"> <button type="submit" ng-disabled="formContact.$invalid" class="mt-1 w-100 btn-danger btn-radius btn-xs btn btn-loader" ng-click="$ctrl.checkContactBeforeSave()" promise-btn> <span class="btn-text">Enregistrer</span></button></div></div><div class="clearfix"></div><div class="col-xs-12 col-md-12" ng-if="$ctrl.getMessageDenonciation($root.membreConnecter)"><div class="custom-alert alert-info mt-1"><p ng-bind-html="$ctrl.messageDenonciation"></p></div></div></div></div></div><div class="clearfix"></div></div><div class="panel-footer hidden-lg hidden-md hidden-sm" ng-show="$ctrl.displayPanel"> <span ng-click="$ctrl.displayPanel = false"><i class="material-icons">remove</i>Masquer le d\xE9tail</span></div></div><div class="spacer spacer--xs"></div><div class="row" ng-if="$ctrl.contact.id"><div class="col-xs-12 col-sm-12 relative pa-xs-0"><div class="tab-container" type="tabs"><ul class="nav nav-tabs contact-nav-tabs"><li ng-repeat="tab in $ctrl.tabsData" class="tab uib-tab nav-item" ui-sref="{{ tab.route }}" ui-sref-active="active" ng-if="!tab.disable"> <span class="tab-counter" ng-if="tab.data[tab.heading] != undefined">{{tab.data[tab.heading]}}</span> <a class="nav-link hidden-xs hidden-sm">{{ tab.heading }}</a> <a class="nav-link hidden-lg hidden-md hidden-lg"><i class="material-icons">{{ tab.icon }}</i></a></li></ul><div class="tab-content"><div class="tab-pane active"><ui-view autoscroll="true"></ui-view></div></div></div><div class="row"><div class="col-xs-12 col-md-6"><div ng-if="formContact.$invalid"><div class="alert alert-danger"><p>Vous avez une ou plusieurs erreurs dans le formulaire :</p><ul><ng-messages for="formContact.nom.$error"><ng-message when="required"><li>Le nom</li></ng-message></ng-messages><ng-messages for="formContact.prenom.$error"><ng-message when="required"><li>Le pr\xE9nom</li></ng-message></ng-messages><ng-messages for="formContact.email.$error"><ng-message when="required, email"><li>L\'email</li></ng-message></ng-messages><ng-messages for="formContact.tel.$error"><ng-message when="required, pattern"><li>Le t\xE9l\xE9phone fixe</li></ng-message></ng-messages><ng-messages for="formContact.tel_mobile.$error"><ng-message when="required, pattern"><li>Le t\xE9l\xE9phone portable</li></ng-message></ng-messages><ng-messages for="formContact.complement_origine.$error"><ng-message when="required"><li>L\'origine du contact</li></ng-message></ng-messages><ng-messages for="formContact.complement_source.$error"><ng-message when="required"><li>La source du contact</li></ng-message></ng-messages></ul></div></div></div></div></div></div></form><div class="spacer spacer--xs"></div>');
$templateCache.put('src/form-contact/modal-confirmation.html','<div class="modal-header"><h3 class="modal-title h4" id="modal-title">Confirmation</h3></div><div class="modal-body" id="modal-body"> Vous avez des modifications non enregistr\xE9es, \xEAtes-vous s\xFBr de quitter la page ?</div><div class="modal-footer"> <button class="btn btn-primary" type="button" ng-click="$ctrl.valider()">Continuer</button> <button class="btn btn-danger" type="button" ng-click="$ctrl.annuler()">Annuler</button></div>');
$templateCache.put('src/form-contact/modal/modal-confirmation-trouver-biens-correspondants.html','<div class="modal-header"> <button type="button" class="close" ng-click="$close()"><span>&times;</span></button><h3 class="modal-title" id="modal-title">Confirmation</h3></div><div class="modal-body" id="modal-body"><div class="row"><div class="col-xs-12"><p>Vous avez modifi\xE9 les crit\xE8res de recherche du contact</p><p>Souhaitez-vous enregistrer les informations du contact avant de lancer la recherche ?</p></div></div></div><div class="modal-footer"> <button class="btn btn-danger btn-sm" type="button" ng-click="$ctrl.annuler()">Rechercher sans tenir compte des modifications</button> <button class="btn btn-primary btn-sm" type="button" ng-click="$ctrl.valider()" promise-btn><span class="btn-text">Mettre \xE0 jour le contact puis rechercher</span></button></div>');
$templateCache.put('src/form-contact/tabs/besoin.html','<div class="d-grid content-between h-100"><div><div class="row--sm"><div class="col-xs-2 col-md-2"></div><div class="col-xs-12 col-md-10"><div class="col-title text-left"><h3>Besoin<i class="fa fa-caret-right"></i></h3></div></div><div class="clearfix"></div><div class="col-xs-12 col-md-12"><div class="form-group text-left m-0"> <label>Ville</label><search-ville search="$ctrl.labelVilleSouhaitee" ville-selected="$ctrl.villeSelected"/></div></div><div class="col-xs-12 col-md-12"><div class="form-group text-left m-0"> <label>Programme</label><div class="form-group--select" ng-if="$ctrl.listProgrammes.length"> <i class="material-icons">arrow_drop_down</i><multiselect ng-disabled="$ctrl.loading" id="programme" name="programme" model-string-to-object-array classes-btn="\'form-control\'" ng-model="$ctrl.contact.preferences_programmes" options="$ctrl.listProgrammes" placeholder="Programme" labels="$ctrl.labelMultiSelect" id-prop="id" display-prop="nom" show-search="false" show-select-all="false" show-unselect-all="false" ng-click="$ctrl.changeParamsTrouverBiensCorrespondants = true"></multiselect></div></div></div><div class="col-xs-12 col-md-6"><div class="form-group text-left m-0"> <label>Destination</label><div class="form-group--select"> <i class="material-icons">arrow_drop_down</i> <select name="besoin" class="form-control" ng-model="$ctrl.contact.preferences_besoin" ng-change="$ctrl.changeParamsTrouverBiensCorrespondants = true"><option value="">Habiter/Investir</option><option value="habiter">Habiter</option><option value="investir">Investir</option></select></div></div></div><div class="col-xs-12 col-md-3"><div class="form-group text-left m-0"> <label>Type</label><div class="form-group--select"> <i class="material-icons">arrow_drop_down</i><div class="form-group--select" ng-if="$ctrl.listTypes.length"> <i class="material-icons">arrow_drop_down</i><multiselect id="etages" name="etages" classes-btn="\'form-control\'" model-string-to-object-array ng-model="$ctrl.contact.preferences_type" options="$ctrl.listTypes" placeholder="Type" labels="$ctrl.labelMultiSelect" display-prop="label" id-prop="id" id-prop-is-integer="false" show-search="false" show-select-all="false" show-unselect-all="false" ng-change="$ctrl.changeParamsTrouverBiensCorrespondants = true"></multiselect></div></div></div></div><div class="col-xs-12 col-md-3"><div class="form-group text-left m-0"> <label>\xC9tage</label><div class="form-group--select" ng-if="$ctrl.listEtages.length"> <i class="material-icons">arrow_drop_down</i><multiselect id="etages" name="etages" classes-btn="\'form-control\'" model-string-to-object-array ng-model="$ctrl.contact.preferences_etage" options="$ctrl.listEtages" placeholder="\xC9tage" labels="$ctrl.labelMultiSelect" display-prop="label" id-prop="label" id-prop-is-integer="false" show-search="false" show-select-all="false" show-unselect-all="false" ng-change="$ctrl.changeParamsTrouverBiensCorrespondants = true"></multiselect></div></div></div></div><div class="row"><div class="col-xs-12 col-md-4 hidden"><div class="form-group text-left m-0"> <label>Rayon</label><rzslider rz-slider-model="$ctrl.contact.preferences_ville_rayon" rz-slider-options="$ctrl.sliderVilleSouhaitRayonOptions"/></div></div></div><div class="row"><div class="col-xs-12 col-md-4 hidden"><div class="form-group text-left m-0"> <label>P\xE9riode d\'achat</label><div class="form-group--select"> <i class="material-icons">arrow_drop_down</i> <select class="form-control" ng-model="$ctrl.contact.complement_date_periode_achat" ng-options="option.value as option.label group by option.year for option in $ctrl.tabPeriodeAchat" ng-change="$ctrl.selectedPreferencesPeriodeAchat($ctrl.contact.complement_date_periode_achat)" ng-change="$ctrl.changeParamsTrouverBiensCorrespondants = true"></select></div></div></div></div><div class="row"><div class="col-xs-12 col-md-7"><div class="form-group text-left m-0"> <label>Dispositif fiscal</label><div class="form-group--select" ng-if="$ctrl.listDispositifFiscal.length"> <i class="material-icons">arrow_drop_down</i><multiselect id="dispositif_fiscal" name="dispositif_fiscal" classes-btn="\'form-control\'" model-string-to-object-array ng-model="$ctrl.contact.preferences_fiscalites_ids" options="$ctrl.listDispositifFiscal" placeholder="Choisissez un dispositif" labels="$ctrl.labelMultiSelect" display-prop="label" id-prop="id" show-search="false" show-select-all="false" show-unselect-all="false" ng-change="$ctrl.changeParamsTrouverBiensCorrespondants = true"></multiselect></div></div></div><div class="col-xs-12 col-md-5"><div class="mt-2 mb-1 txt-left"> <input type="checkbox" id="preferences_programme_venir" ng-model="$ctrl.contact.preferences_programme_venir" ng-change="$ctrl.changeParamsTrouverBiensCorrespondants = true"/> <label for="preferences_programme_venir" class="checkbox">Programme \xE0 venir</label></div></div></div><div class="row mb-1 mt-1" ng-if="$ctrl.slidersurfaces"><div class="col-xs-12 col-md-12"><div class="text-left slider-title"> <label>Surface</label></div><idsk-slider slider-model="$ctrl.slidersurfaces.min" slider-high="$ctrl.slidersurfaces.max" slider-options="$ctrl.slidersurfaces.options"></idsk-slider></div></div><div class="row mb-1 mt-05" ng-if="$ctrl.sliderbudget"><div class="col-xs-12 col-md-12"><div class="text-left slider-title"> <label>Budget</label></div><idsk-slider slider-model="$ctrl.sliderbudget.min" slider-high="$ctrl.sliderbudget.max" slider-options="$ctrl.sliderbudget.options"></idsk-slider></div></div><div><div class="row mb-1"><div class="col-xs-12"> <button ng-show="$ctrl.contact.id" type="button" class="w-100 btn btn-success btn-outline btn-radius btn-sm clr-black" ng-click="$ctrl.trouverBiensCorrespondants()" promise-btn> <span class="btn-text">Trouver les biens correspondants</span></button></div></div></div><div class="row"><div class="col-xs-12 col-sm-12"><div class="form-group text-left mb-0"> <label>Note compl\xE9mentaire</label><textarea class="form-control " rows="7" ng-model="$ctrl.contact.preferences_note_besoin" ng-change="$ctrl.changeParamsTrouverBiensCorrespondants = true"></textarea></div></div></div></div></div>');
$templateCache.put('src/form-contact/tabs/co-acquereurs.html','<div class="clearfix"><div class="row  "><div class="col-sm-12"><coacquereurs contact="contactCtrl.contact"></coacquereurs></div></div></div>');
$templateCache.put('src/form-contact/tabs/denonciations.html','<div class="clearfix"><div class="row "><div class="col-sm-12"><liste-denonciations contact="contactCtrl.contact"></liste-denonciations></div></div></div>');
$templateCache.put('src/form-contact/tabs/documents.html','<div class="clearfix"><div class="row "><div class="col-sm-12"><list-demandes-documents contact="contactCtrl.contact" show-col-checkbox="false" ng-if="contactCtrl.cContact.statut_activation"></list-demandes-documents><div class="spacer spacer--xs"></div><liste-documents-contact contact="contactCtrl.contact" show-panel-heading="false"></liste-documents-contact></div></div></div>');
$templateCache.put('src/form-contact/tabs/historique.html','<div class="row mb-1"><div class="col-md-12"> <button class="btn btn-primary btn-lg btn-iconned btn-iconned--left mr-05 " ng-click="contactCtrl.newAction()"><i class="material-icons">add_circle</i>Ajouter une action</button></div></div><historiques-contact contact="contactCtrl.contact"></historiques-contact>');
$templateCache.put('src/form-contact/tabs/infos-complementaires.html','<div class="row"><div class="col-sm-12 col-md-6"><div class="form-group"> <label>Civilit\xE9&nbsp;:</label><div class="form-group--select"> <i class="material-icons">arrow_drop_down</i> <select class="form-control" name="civilite_conjoint" ng-model="contactCtrl.contact.civilite_conjoint"><option value="M" label="M.">M.</option><option value="F" label="Mme">Mme</option><option value="MF" label="M. et Mme">M. et Mme</option></select></div></div><div class="form-group"> <label>Nom conjoint&nbsp;:</label> <input class="form-control" name="nom_conjoint" type="text" ng-model="contactCtrl.contact.nom_conjoint"></div><div class="form-group"> <label>T\xE9l. conjoint:</label> <input class="form-control" name="tel_conjoint" type="text" ng-model="contactCtrl.contact.tel_conjoint"></div><div class="form-group"> <label>R\xE9g. matrimonial&nbsp;:</label> <input class="form-control" name="regime_matrimonial" type="text" ng-model="contactCtrl.contact.regime_matrimonial"></div><div class="form-group"> <label>NB enfant&nbsp;:</label> <input class="form-control" min="0" name="nb_enfants" type="number" ng-model="contactCtrl.contact.nb_enfants"></div></div><div class="col-sm-12 col-md-6"><div class="form-group"> <label>Situ. famille&nbsp;:</label> <input class="form-control" name="situation_famille" type="text" ng-model="contactCtrl.contact.situation_famille"></div><div class="form-group"> <label>Pr\xE9nom conjoint&nbsp;:</label> <input class="form-control" name="prenom_conjoint" type="text" ng-model="contactCtrl.contact.prenom_conjoint"></div><div class="form-group"> <label>Revenus annuels&nbsp;:</label> <input class="form-control" name="revenu_annuel" type="text" ng-model="contactCtrl.contact.revenu_annuel"></div><div class="form-group"> <label>TMI&nbsp;:</label> <input class="form-control" name="tmi" type="text" ng-model="contactCtrl.contact.tmi"></div><div class="form-group"> <label>Montant imp\xF4t&nbsp;:</label> <input class="form-control" name="impots" type="text" ng-model="contactCtrl.contact.impots"></div></div><div class="col-sm-12"><div class="form-group"> <label>Note&nbsp;:</label><textarea class="form-control" rows="8" name="complement_situation_note" ng-model="contactCtrl.contact.complement_situation_note"></textarea></div></div></div></uib-tab>');
$templateCache.put('src/form-contact/tabs/note.html','<div class="form-group mb-0"><textarea class="form-control" rows="10" ng-model="contactCtrl.contact.complement_situation_note"></textarea></div>');
$templateCache.put('src/form-contact/tabs/panier.html','<panier contact="contactCtrl.contact" hide-panel-heading="true"></panier>');
$templateCache.put('src/form-contact/tabs/transactions.html','<transactions-contact contact="contactCtrl.contact"></transactions-contact>');}]);